import { StylesConfig } from 'react-select';
import { OptionType } from 'components/CustomSelect/types';

export const filteredMultipleListStyles: StylesConfig<OptionType, false> = {
  option: styles => ({
    ...styles,
    padding: '6.8px 12px',
  }),
};

export const metricValueListStyles: StylesConfig<OptionType, false> = {
  option: styles => ({
    ...styles,
    padding: '6.8px 12px',
  }),
};
